
import React, { useState, useContext, createContext, useLayoutEffect, useEffect } from "react";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import "./styles.css";

import LoginComponent from "./Login/login";
import MenuComponent from "./Menu/menu";

import { Box } from "@mui/material";

import { AuthProvider, AuthContext } from "../contexts/auth";

import Home from "./Home/home";
import Loader from "./Loader/loader";
import Eventos from "./Eventos";
import Credenciados from "./Credenciados";

import { Toaster } from 'react-hot-toast'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ptBR as datagridptBR } from '@mui/x-data-grid';


import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ptBR from 'dayjs/locale/pt-br';
import { ptBR as localePTBR } from '@mui/x-date-pickers/locales';
import Settings from "./Settings";
import RelatoriosIndex from "./Relatorios";
import GraficosIndex from "./Graficos";

export const mobileWidth = '768'

export const externalComponent = createContext()

const theme = createTheme(
  {
    palette: {
      primary: { main: '#082f49' },
    },
  },
  datagridptBR,
);

export const useWindowSize = () => {
  const [size, setSize] = useState([0, 0]);

  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }

    window.addEventListener('resize', updateSize);
    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
}



const PrivateRoute = ({ botmenu, permission, component }) => {
  const [width] = useWindowSize();
  const { authenticated, loading } = useContext(AuthContext);
  const [loader, setLoader] = useState(false)
  const isMobile = width <= mobileWidth

  if (loading) {
    return <Loader external show={true} />;

  }

  if (!authenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <externalComponent.Provider value={{ setLoader, width, isMobile }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ptBR}
            localeText={localePTBR.components.MuiLocalizationProvider.defaultProps.localeText}
          >
            <Loader external show={loader} />
            <Box className="main-screen">
              <Box sx={{ flex: 9, overflow: 'hidden' }}>{component &&
                <Box className={'default_padding'}>
                  {width <= mobileWidth && <Box sx={{ height: '3rem' }}></Box>}
                  {component}
                </Box>
              }
              </Box>

              < >{botmenu && <MenuComponent />}</>
            </Box>
          </LocalizationProvider>
        </externalComponent.Provider>
      </ThemeProvider>
    </>

  );
};



const AppRoutes = () => {

  return (

    <Router>
      <Toaster position='bottom-center' />
      <AuthProvider>
        <Routes>
          <Route exact path="/login" element={<LoginComponent />} />

          <Route
            exact
            path="/"
            element={
              <PrivateRoute botmenu permission={true} component={<Home />} />
            }
          />

          <Route
            exact
            path="/eventos"
            element={
              <PrivateRoute botmenu permission={true} component={<Eventos />} />
            }
          />

          <Route
            exact
            path="/credenciados"
            element={
              <PrivateRoute botmenu permission={true} component={<Credenciados />} />
            }
          />

          <Route
            exact
            path="/relatorios"
            element={
              <PrivateRoute botmenu permission={true} component={<RelatoriosIndex />} />
            }
          />

          <Route
            exact
            path="/graficos"
            element={
              <PrivateRoute botmenu permission={true} component={<GraficosIndex />} />
            }
          />

          <Route
            exact
            path="/configuracoes"
            element={
              <PrivateRoute botmenu permission={true} component={<Settings />} />
            }
          />

        </Routes>



      </AuthProvider>
    </Router>
  );
};

export default AppRoutes;
